import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { SnShare } from '@lib/api/entities';

@Component({
  selector: 'sn-share-details',
  templateUrl: './share-details.component.html',
  styleUrls: ['./share-details.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShareDetailsComponent {
  @Input()
  public share: SnShare;

  constructor() {}
}
